import {useState, useEffect} from 'react'
import Style from './style'

const SupabaseConnectError = ({isVisible = false, status = ''}) => {
	const [isExpanded, setIsExpanded] = useState(false)

	const isMaxRetries = status === 'MAX_RETRIES_EXCEEDED'

	// Auto-reload when max retries is reached
	useEffect(() => {
		if (isVisible && isMaxRetries) {
			console.log('Max retries exceeded, auto-reloading page...')
			window.location.reload()
		}
	}, [isVisible, isMaxRetries])

	if (!isVisible) {
		return null
	}

	const handleToggle = () => {
		setIsExpanded((prev) => !prev)
	}

	// Collapsed state - small circle indicator
	if (!isExpanded) {
		return (
			<Style.CollapsedIndicator
				onClick={handleToggle}
				$isMaxRetries={isMaxRetries}
				title='Click to expand connection status'
			>
				<Style.PulsingDot $isMaxRetries={isMaxRetries} />
			</Style.CollapsedIndicator>
		)
	}

	// Expanded state - full message
	return (
		<Style.Container onClick={handleToggle}>
			<Style.Icon>🔄</Style.Icon>
			<Style.Message>
				{`Connection issue (${status}), reconnecting...`}
			</Style.Message>
		</Style.Container>
	)
}

export default SupabaseConnectError
